import React from "react";
import spinnerSVG from "./bars-rotate-fade.svg"

const Spinner = () => (
	<div style={{display:"flex", justifyContent:"center", alignItems:"center", width:"100vw", height:"100vh", position:"absolute", right:"0"}}>
		<img src={ spinnerSVG } style={{width: "50px" }} />
	</div>
)

export default Spinner;